import SliceNames from '@/state/enum';
import { BrandState } from '@/state/slices/brand/typings';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const brand =
	EnvVarsService.getVar<BrandState[SliceNames.BRAND]['brand']>('VITE_BRAND');

const brandState: BrandState = {
	[SliceNames.BRAND]: {
		brand,
	},
};

export default brandState;
